export const DATABASE_NAME = "audioDatabase";
export const PREVIOUS_SESSION = "previousSession";
export const COMMIT_SHA = import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA || 'dev'
